import React from 'react';
import { createRoot } from 'react-dom/client'

// we use tabs on the page to switch b/w pay-as-you-go and subscriptions
import 'bootstrap/js/src/tab';

// Import Bootstrap styles on top of global Replate styles in app/assets/stylesheets/
import '../stylesheets/custom.scss';
import 'bootstrap/scss/bootstrap-utilities.scss';

import '../stylesheets/pricingPage.scss';

import PricingPageCalculator from '../src/components/pricingPageCalculator/PricingPageCalculator';

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.getElementsByClassName('custom-calculator-container');

  Array.from(containers).forEach((container) => {
    const propsNode = container.querySelector('.customCalcProps');
    const customPricing = JSON.parse(propsNode.getAttribute('custompricing'));

    const root = createRoot(container)

    root.render(
      <PricingPageCalculator
        customPricing={customPricing}
      />
    );
  });
});
